import TaxStatusEnum from '@constants/enums/taxStatus';

const ListingStatusEnum = Object.freeze({
    UNLISTED: [
        TaxStatusEnum.ALTS,
        TaxStatusEnum.EIS,
        TaxStatusEnum.IHT,
        TaxStatusEnum.NQ,
        TaxStatusEnum.SEIS,
        TaxStatusEnum.SEISEIS,
        TaxStatusEnum.SITR,
        TaxStatusEnum.SINGLE_COMPANY,
        'DIRECT_BR'
    ],
    LISTED: [TaxStatusEnum.VCT, TaxStatusEnum.IHT, TaxStatusEnum.PMI, TaxStatusEnum.HYBRID]
});

export default ListingStatusEnum;
